import { DictionaryObject } from '@eas/common-web';
import { FinancialStatementAuditType } from '@enums';

export function useTradingCompanyCategories(): DictionaryObject[] {
  return [
    {
      id: TradingCompanyCategoryEnum.LARGE_COMPANY,
      name: 'VOS (Veľká obchodná spoločnosť, ktorá spĺňa veľkostné kritéria podľa § 2 ods. 15 písm. f) prvého bodu zákona č. 423/2015 Z. z.)',
    },
    {
      id: TradingCompanyCategoryEnum.STATE_INTEREST,
      name: 'ŠÚJ (Štátny podnik a obchodná spoločnosť s majetkovou účasťou štátu)',
    },
    {
      id: TradingCompanyCategoryEnum.REGION,
      name: 'VÚC (Vyšší územný celok)',
    },
    {
      id: TradingCompanyCategoryEnum.MUNICIPALITY,
      name: 'Obec/mesto (Obec, mesto alebo mestská časť)',
    },
  ];
}

export function getFinancialStatementAuditTypeLabel(
  type: FinancialStatementAuditType | string
): string {
  switch (type) {
    case FinancialStatementAuditType.STATUTORY_AUDIT:
      return 'Štatutárný audit';
    case FinancialStatementAuditType.ESG_ASSURANCE:
      return 'ESG uistenie';
    case FinancialStatementAuditType.COMBINED_AUDIT:
      return 'Spoločné';
    default:
      return '--';
  }
}

export enum TradingCompanyCategoryEnum {
  // súčasná veľká obchodná spoločnosť
  LARGE_COMPANY = 'LARGE_COMPANY',
  // účtovná jednotka s účasťou štátu
  STATE_INTEREST = 'STATE_INTEREST',
  // vyšší územný celok
  REGION = 'REGION',
  // veľká obec, mesto alebo mestská časť
  MUNICIPALITY = 'MUNICIPALITY',
}
